export const DATA_CORE_BASE_PATHS = [
  '/projects',
  '/sources',
  '/storages',
  '/storage',
  '/integrations',
  '/connections',
  '/tasks',
  '/reporting',
  '/cdp',
  '/feature-store',
];

export const PROJECT_SCOPED_EXTRA_PATHS = ['/rag', '/library'];

export const isDataCorePath = (pathname = '') =>
  DATA_CORE_BASE_PATHS.some((basePath) => pathname === basePath || pathname.startsWith(`${basePath}/`));

export const isProjectScopedPath = (pathname = '') => {
  if (isDataCorePath(pathname)) return true;
  return PROJECT_SCOPED_EXTRA_PATHS.some(
    (basePath) => pathname === basePath || pathname.startsWith(`${basePath}/`)
  );
};

export const getProjectIdFromPath = (pathname = '') => {
  const match = pathname.match(/^\/projects\/([^/]+)/);
  if (!match?.[1] || match[1] === 'create') return null;
  return match[1];
};

/**
 * Приоритет: db_name из URL → db_name из /projects/:id → сохранённый контекст.
 */
export const getEffectiveProjectDbName = ({
  search = '',
  activeDbName = '',
  pathDbName = '',
} = {}) => {
  const fromUrl = getProjectNameFromSearch(search);
  if (fromUrl) return fromUrl;
  if (pathDbName) return pathDbName;
  if (activeDbName) return activeDbName.trim();
  return '';
};

export const getProjectNameFromSearch = (search = '') => {
  const params = new URLSearchParams(search);
  const dbName = params.get('db_name');
  if (dbName && dbName.trim()) return dbName.trim();

  const legacyProjectName = params.get('project_name');
  return legacyProjectName ? legacyProjectName.trim() : '';
};

export const buildPathWithProjectName = (path, projectName = '') => {
  const [pathname, rawSearch = ''] = path.split('?');
  const params = new URLSearchParams(rawSearch);
  const normalizedProjectName = (projectName || '').trim();

  if (normalizedProjectName) {
    params.set('db_name', normalizedProjectName);
    params.delete('project_name');
  } else {
    params.delete('db_name');
    params.delete('project_name');
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const getProjectDisplayName = (project) =>
  project?.project_title?.trim() || project?.db_name?.trim() || project?.name?.trim() || '';
